export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes1_sell.1c1e2f43.mp3";